window.EditGoodFaithEstimateShiftsForm = function ($scope, positionsDataService, businessDayUtils, ShiftTemplateUtils ,hUser ,$q, GoodFaithEstimateScheduleDataService) {
    var self = this;
    var formName = 'edit-good-faith-estimate-shifts-form';
    var _protected = BaseForm.call(self, formName, $scope);
    var businessDay;
    var _day;
    var gfeDataService;

    self.load = function (mode, shift, day, businessDayDetails, docCode, brandId, regularScheduleSettings) {
        businessDay = businessDayDetails; // today normalized businessDay
        _day = day;
        self.docCode = docCode;
        self.shift = shift;
        self.location_variation_enabled = regularScheduleSettings['location_variation_enabled'];
        self.only_regular_shift_type = regularScheduleSettings['only_regular_shift_type'];
        self.businessDayLimits = businessDayUtils.getBusinessDayLimits(businessDay, _day);
        self.startTimeOptions = hTimePickerUtils.getIntervalOptions( {
            from: self.businessDayLimits.openTime,
            to: self.businessDayLimits.closeTimeWithoutExtension,
            withInfo: false,
            minutesPeriod: 15,
            includeFrom: true,
            includeTo: false,
            closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
        });

        if (self.shift.start_time) {
            self.shift.start_time = moment(self.shift.start_time);
        }
        if (self.shift.end_time) {
            self.shift.end_time = moment(self.shift.end_time);
        }
        const businessDayIntersection = businessDayUtils.getBusinessDayIntersection(self.shift, _day, false, false, false, businessDay);
        if (businessDayIntersection.in_extension) {
            self.end_time_meta = {
                appendText: $filter('translate')('Next Day'),
                prependIcon: 'next-day-icon'
            }
        }
        self.onStartTimeChanged();
        self.shift.shift_type = shift.shift_type || 'REGULAR';
        gfeDataService = GoodFaithEstimateScheduleDataService();

        if (self.docCode === 'GOOD_FAITH_ESTIMATE_SCHEDULE_LITE') {
            self.isLocationsDropdownShown = regularScheduleSettings.can_specify_location;
        } else {
            self.isLocationsDropdownShown = true;
        }
        self.loading = true;
        self.locations = [];
        var promises = {
            brandDetails: gfeDataService.getBrandDetails(brandId)
        };

        if (self.isLocationsDropdownShown) {
            promises['brandsFinancialUnits'] = BrandAPI.getBrandsFinancialUnits(brandId,{types:['enterprise','child']});
        }
        if (self.docCode !== 'GOOD_FAITH_ESTIMATE_SCHEDULE_PHILADELPHIA') {
            promises['activePositionsFlat'] = positionsDataService.getActivePositionsFlat(false, brandId)
        }
        $q.all(promises)
            .then(function (result) {
                self.locations = result['brandsFinancialUnits'] || [];
                self.shift.location = angular.copy(result['brandDetails']);
                self.positions = result['activePositionsFlat'] || [];
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                self.loading = false;
                $scope.$digest();
            });
    };

    self.isSaveBtnDisabled = function () {
        return (
            self.isSaving ||
            self.loading
        )
    };

    self.onStartTimeChanged = function () {
        if (!self.shift['start_time']) {
            self.shiftEndTimeOptions = [];
        } else {
            let to = self.businessDayLimits.closeTime;
            const startTimePlusOneDay = self.shift.start_time.clone().add(1, 'day');

            if (startTimePlusOneDay.isBefore(self.businessDayLimits.closeTime)) {
                to = startTimePlusOneDay;
            }

            self.shiftEndTimeOptions = hTimePickerUtils.getIntervalOptions( {
                from: self.shift['start_time'],
                to: to,
                withInfo: true,
                minutesPeriod: 15,
                includeFrom: false,
                includeTo: true,
                closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
            });
        }
    };

    self.onTimeChangeValidate = function (target) {
        return function (value) {
            if (value && value.isValid()) {
                var from = self.businessDayLimits.openTime;
                var to = self.businessDayLimits.closeTime;
                if (value.isBefore(from)) {
                    value.add(1, 'day');
                }
                if (value.isAfter(to)) {
                    value.subtract(1, 'day');
                }
                if (target == 'from') {
                    if (value.isAfter(to)) {
                        value = from;
                    }
                } else if (target == 'to') {
                    if (value.isBefore(from)) {
                        value = to;
                    }
                }
            }
            return value;
        }
    }


    self.onOptionSelect = function (target) {
        return function (option) {
            var metaObj = {};
            if (option.next_day) {
                metaObj.appendText = $filter('translate')('Next Day');
                metaObj.prependIcon = 'next-day-icon';
            }
            else {
                metaObj.appendText = '';
                metaObj.prependIcon = '';
            }
            self[target + '_meta'] = metaObj;
        }
    };

    var prepareSavedShiftData = function() {
        var normalizedShift = businessDayUtils.normalizeTimeIntervals([{start_time: self.shift.start_time , end_time: self.shift.end_time }], businessDay.open_time)[0];
        var shiftPeriod = ShiftTemplateUtils.getPeriod((normalizedShift['start_time'] / 1000), (normalizedShift['end_time'] / 1000), _day);
        return {
            shift_type: self.shift.shift_type,
            location: self.shift.location || {},
            position: self.shift.position && {
                id: self.shift.position['id'],
                name: self.shift.position['name'],
                code: self.shift.position['code']
            },
            start_time: shiftPeriod['start'],
            end_time: shiftPeriod['end'],
            day: moment(_day).format("ddd").toUpperCase(),
            type: self.shift.shift_type,
        }
    };

    self.save = function () {
        var defer = $q.defer();

        self.validator.validate(function (isValid) {
            if (isValid) {
                self.isSaving = true;

                if (self.shift.location && self.shift.location['id']) {
                    gfeDataService.getBrandDetails(self.shift.location['id'])
                        .then(function (brandDetails) {
                            self.shift.location = angular.copy(brandDetails);
                            defer.resolve(prepareSavedShiftData());
                        })
                        .catch(function (error) {
                            console.error(error)
                        })
                        .finally(function () {
                            self.isSaving = false;
                        })
                }
                else {
                    defer.resolve(prepareSavedShiftData());
                }
            }
            else {
                defer.reject({ code: 'VALIDATION_ERROR'});
            }
        });

        return defer.promise;
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
            case "time":
                return /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/.test(value);

            case "within-business-day":
                if (
                    self.shift.start_time &&
                    self.shift.end_time
                ) {
                    var shiftInterval = {start_time: self.shift.start_time, end_time: self.shift.end_time};
                    return !!businessDayUtils.isWithinBusinessDay(shiftInterval, _day, false, false, false, businessDay);
                }
                break;

            case "start_end_time":
                    if (self.shift.end_time) {
                        var startTime = new Date(self.shift.start_time).getTime();
                        var endTime = new Date(self.shift.end_time).getTime();
                        var shiftLength = Math.abs(startTime - endTime);
                        return shiftLength >= (15 * 60 * 1000);
                    }

                break;
        }
        return true;
    };
};

